/* =========================================================
   Promo-Bar — Close, Copy-to-Clipboard, Countdown, Cart-Update
   ========================================================= */
(function () {
  const CLOSE_STORAGE_KEY = 'promoBarDismissed';

  // ---------- Close-Button ----------
  function getDismissedIds() {
    try {
      const raw = sessionStorage.getItem(CLOSE_STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (_) { return []; }
  }

  function saveDismissedId(id) {
    try {
      const ids = getDismissedIds();
      if (!ids.includes(id)) {
        ids.push(id);
        sessionStorage.setItem(CLOSE_STORAGE_KEY, JSON.stringify(ids));
      }
    } catch (_) {}
  }

  function applyDismissedState() {
    const dismissed = getDismissedIds();
    document.querySelectorAll('.promo-bar[data-section-id]').forEach((bar) => {
      if (dismissed.includes(bar.dataset.sectionId)) {
        bar.setAttribute('hidden', '');
      }
    });
  }

  function bindCloseButtons() {
    document.querySelectorAll('[data-promo-close]').forEach((btn) => {
      if (btn.__bound) return;
      btn.__bound = true;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const bar = btn.closest('.promo-bar');
        if (!bar) return;
        saveDismissedId(bar.dataset.sectionId);
        bar.setAttribute('hidden', '');
      });
    });
  }

  // ---------- Copy-to-Clipboard ----------
  function bindCopyButtons() {
    document.querySelectorAll('[data-copy-code]').forEach((btn) => {
      if (btn.__bound) return;
      btn.__bound = true;
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const code = btn.dataset.copyCode || '';
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
          } else {
            // Fallback
            const ta = document.createElement('textarea');
            ta.value = code;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
          }
          showCopiedState(btn);
        } catch (err) {
          console.warn('Promo-Bar: Copy fehlgeschlagen', err);
        }
      });
    });
  }

  function showCopiedState(btn) {
    const defaultLabel = btn.querySelector('.promo-bar__btn-label:not(.promo-bar__btn-label--copied)');
    const copiedLabel = btn.querySelector('.promo-bar__btn-label--copied');
    if (!defaultLabel || !copiedLabel) return;
    defaultLabel.hidden = true;
    copiedLabel.hidden = false;
    btn.classList.add('promo-bar__btn--copied');
    clearTimeout(btn.__copiedTimer);
    btn.__copiedTimer = setTimeout(() => {
      defaultLabel.hidden = false;
      copiedLabel.hidden = true;
      btn.classList.remove('promo-bar__btn--copied');
    }, 2000);
  }

  // ---------- Countdown ----------
  function pad(n) { return String(n).padStart(2, '0'); }

  function updateCountdown(block) {
    const endStr = block.dataset.countdown;
    if (!endStr) return;
    const end = new Date(endStr).getTime();
    if (isNaN(end)) return;
    const diff = end - Date.now();
    const display = block.querySelector('[data-countdown-display]');
    if (!display) return;
    if (diff <= 0) {
      display.querySelector('[data-countdown-d]').textContent = '00';
      display.querySelector('[data-countdown-h]').textContent = '00';
      display.querySelector('[data-countdown-m]').textContent = '00';
      display.querySelector('[data-countdown-s]').textContent = '00';
      return false;
    }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    display.querySelector('[data-countdown-d]').textContent = pad(d);
    display.querySelector('[data-countdown-h]').textContent = pad(h);
    display.querySelector('[data-countdown-m]').textContent = pad(m);
    display.querySelector('[data-countdown-s]').textContent = pad(s);
    return true;
  }

  function startCountdowns() {
    const blocks = document.querySelectorAll('.promo-bar__block--countdown');
    if (!blocks.length) return;
    blocks.forEach(updateCountdown);
    setInterval(() => blocks.forEach(updateCountdown), 1000);
  }

  // ---------- Shipping-Progress (Cart-Update) ----------
  function formatMoneyCents(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      const fmt = (window.theme && window.theme.moneyFormat) || '€{{amount}}';
      return Shopify.formatMoney(cents, fmt);
    }
    // Fallback (EUR)
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateShippingBlock(block, cartTotal) {
    const threshold = parseInt(block.dataset.threshold, 10);
    if (!threshold) return;
    const remaining = Math.max(0, threshold - cartTotal);
    const pct = Math.min(100, (cartTotal / threshold) * 100);
    const textEl = block.querySelector('[data-shipping-text]');
    const barEl = block.querySelector('[data-shipping-bar]');
    if (barEl) barEl.style.width = pct + '%';
    if (textEl) {
      if (remaining === 0) {
        textEl.textContent = block.dataset.textComplete || '';
        block.classList.add('is-complete');
      } else {
        const tpl = block.dataset.textPending || '';
        textEl.textContent = tpl.replace('%REMAINING%', formatMoneyCents(remaining));
        block.classList.remove('is-complete');
      }
    }
  }

  function refreshShippingFromCart() {
    const blocks = document.querySelectorAll('[data-shipping-progress]');
    if (!blocks.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        blocks.forEach((b) => updateShippingBlock(b, cart.total_price));
      })
      .catch(() => { /* noop */ });
  }

  function bindCartEvents() {
    if (!document.querySelector('[data-shipping-progress]')) return;
    // Cart-Events der gängigen Themes/Apps
    ['cart:updated', 'cart:refresh', 'cart:item-added', 'cart:change'].forEach((ev) => {
      document.addEventListener(ev, refreshShippingFromCart);
    });
    // Fallback: nach jedem fetch /cart oder /cart/change
    const origFetch = window.fetch;
    if (origFetch && !origFetch.__promoBarPatched) {
      window.fetch = function (...args) {
        return origFetch.apply(this, args).then((res) => {
          const url = (args[0] && args[0].url) || args[0];
          if (typeof url === 'string' && /\/cart(?:\.js|\/(add|change|update|clear))/.test(url)) {
            setTimeout(refreshShippingFromCart, 50);
          }
          return res;
        });
      };
      window.fetch.__promoBarPatched = true;
    }
  }

  // ---------- Slider (Autoplay) ----------
  const LEAVE_MS = 500;

  function initSlider(bar) {
    if (bar.__promoSlider) return;
    const slides = Array.from(bar.querySelectorAll('.promo-bar__inner > .promo-bar__block'));
    if (slides.length < 2) return;

    const speed = (parseInt(bar.dataset.autoplay, 10) || 5) * 1000;
    const mq = bar.dataset.autoplayScope === 'mobile' ? window.matchMedia('(max-width: 749px)') : null;
    let index = 0;
    let timer = null;
    let hovered = false;
    let pinned = false; // Theme-Editor: Block ausgewählt

    slides.forEach((s, i) => s.classList.toggle('is-active', i === 0));
    bar.classList.add('is-slider-ready');

    function enabled() { return !mq || mq.matches; }

    function show(i) {
      const next = (i + slides.length) % slides.length;
      if (next === index) return;
      const prev = slides[index];
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      setTimeout(() => prev.classList.remove('is-leaving'), LEAVE_MS);
      index = next;
      slides[index].classList.add('is-active');
    }

    function stop() { clearInterval(timer); timer = null; }

    function start() {
      stop();
      if (!enabled() || hovered || pinned || document.hidden) return;
      timer = setInterval(() => show(index + 1), speed);
    }

    bar.addEventListener('mouseenter', () => { hovered = true; stop(); });
    bar.addEventListener('mouseleave', () => { hovered = false; start(); });
    bar.addEventListener('focusin', () => { hovered = true; stop(); });
    bar.addEventListener('focusout', (e) => {
      if (!bar.contains(e.relatedTarget)) { hovered = false; start(); }
    });
    document.addEventListener('visibilitychange', start);
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', start);
      else if (mq.addListener) mq.addListener(start);
    }

    bar.__promoSlider = {
      stop,
      select(el) {
        const i = slides.indexOf(el);
        if (i === -1) return;
        pinned = true;
        stop();
        show(i);
      },
      deselect() { pinned = false; start(); }
    };

    start();
  }

  function initSliders(root) {
    (root || document).querySelectorAll('.promo-bar[data-autoplay]').forEach(initSlider);
  }

  // Theme-Editor: ausgewählten Block anzeigen und Slider pausieren
  document.addEventListener('shopify:block:select', (e) => {
    const bar = e.target.closest && e.target.closest('.promo-bar');
    if (bar && bar.__promoSlider) bar.__promoSlider.select(e.target);
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const bar = e.target.closest && e.target.closest('.promo-bar');
    if (bar && bar.__promoSlider) bar.__promoSlider.deselect();
  });
  document.addEventListener('shopify:section:unload', (e) => {
    const bar = e.target.querySelector && e.target.querySelector('.promo-bar');
    if (bar && bar.__promoSlider) bar.__promoSlider.stop();
  });

  // ---------- Init ----------
  function init() {
    if (!(window.Shopify && Shopify.designMode)) {
      applyDismissedState();
    }
    bindCloseButtons();
    bindCopyButtons();
    startCountdowns();
    bindCartEvents();
    initSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    bindCloseButtons();
    bindCopyButtons();
    startCountdowns();
    initSliders(e.target);
  });
})();
